(function() {
	// Module
	var CanvasVideoPreview = (function() {
		var __private = {
			video: null,
			preview: null,
			scaleFactor: 0.25,
			minW: 210,
			minH: 100,
			snapshots: [],

			set(video, preview) {
				if(video instanceof HTMLVideoElement) this.video = video;
				else throw new Error("Video not found");

				if(preview instanceof HTMLElement) this.preview = preview;
				else throw new Error("Output element for preview not found");
			},

			capture(scaleFactor = __private.scaleFactor) {
				var w = this.video.videoWidth * scaleFactor;
				var h = this.video.videoHeight * scaleFactor;
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');

				if(w < __private.minW) w = __private.minW;
				if(h < __private.minH) h = __private.minH;

				canvas.width  = w;
				canvas.height = h;
				ctx.drawImage(this.video, 0, 0, w, h);

				return canvas;
			},

			shoot(scaleFactor) {
				var canvas = this.capture(scaleFactor);

				this.snapshots.unshift(canvas);
				this.preview.innerHTML = '';
				this.preview.appendChild(this.snapshots[0]);
			}
		};

		return {
			init(video, preview) {
				__private.set(video, preview);
			},

			create(scaleFactor) {
				if(__private.video !== null && __private.preview !== null) __private.shoot(scaleFactor);
			}
		};
	})();

	
	// Run script
	document.addEventListener("DOMContentLoaded", function() {

		var video = document.getElementById("carVideo");
		var preview = document.querySelector(".slide.slide_video");

		if(video instanceof HTMLVideoElement && preview instanceof HTMLElement) {
			CanvasVideoPreview.init(video, preview);
			CanvasVideoPreview.create(0.2);
		}

		// Android test
		/*var play = document.getElementById("videoPlay");
		if(play) play.addEventListener("click", function() {
			setTimeout(() => {
				CanvasVideoPreview.init(video, preview);
				CanvasVideoPreview.create(0.2);
			}, 1000);
		});*/

	});
})();